import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { fetchDrmReportDetails } from "../../service/fetchDrmReportDetails";
import {
  setDrmReportDetailsSuccess,
  setDrmReportDetailsFailure,
  setDrmReportDetailsDownloadSuccess,
  setDrmReportDetailsDownloadFailure,
} from "../reducers/drmReportDetailsSlice";

export function* workerGetDrmReportDetails({ payload }) {
  const controller = new AbortController();
  try {
    const {
      pageNum = 1,
      pageSize = 10,
      reqBody = {},
    } = payload || {};

    const response = yield call(fetchDrmReportDetails, {
      pageNum,
      pageSize,
      requestBody: reqBody,
      controller,
    });

    const details = response?.details || {};
    const data = Array.isArray(details?.data) ? details.data : [];

    yield put(
      setDrmReportDetailsSuccess({
        data,
        onPage: details.onPage ?? pageNum,
        pageSize: details.pageSize ?? pageSize,
        totalPages: details.totalPages ?? 0,
        totalRecords: details.totalRecords ?? data.length,
      })
    );
  } catch (error) {
    const message = error?.message || error?.toString() || "Failed to fetch report details";
    yield put(setDrmReportDetailsFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

export function* workerDownloadDrmReportDetails({ payload }) {
  const controller = new AbortController();
  try {
    const {
      reqBody = {},
      totalPages = 0,
      pageSize = 500,
      fileName = "ReportExport",
    } = payload || {};

    const pagesToFetch = totalPages && totalPages > 0 ? totalPages : 1;
    const aggregatedRows = [];

    for (let page = 1; page <= pagesToFetch; page += 1) {
      const response = yield call(fetchDrmReportDetails, {
        pageNum: page,
        pageSize,
        requestBody: reqBody,
        controller,
      });

      const details = response?.details || {};
      const data = Array.isArray(details?.data) ? details.data : [];
      aggregatedRows.push(...data);
    }

    yield put(
      setDrmReportDetailsDownloadSuccess({
        rows: aggregatedRows,
        fileName,
      })
    );
  } catch (error) {
    const message = error?.message || error?.toString() || "Failed to download report";
    yield put(setDrmReportDetailsDownloadFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmReportDetailsSaga() {
  yield takeLatest(
    "drmReportDetails/getDrmReportDetails",
    workerGetDrmReportDetails
  );
  yield takeLatest(
    "drmReportDetails/downloadDrmReportDetails",
    workerDownloadDrmReportDetails
  );
}

export default drmReportDetailsSaga;
